export default {
    section: 'Additional Details',
    name: 'offer-letter-additional-details',
    items: [
        {
            type: 'textarea',
            text: 'Additional Details',
            name: 'offer-letter-additional-details',
            props: {}
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/offer-letter/valuation-data/additional-details.js